export const DEFAULT_TOOLTIP = {
    gap: '18px',
    position: 'bottom',
};
